import {createSelector} from '@reduxjs/toolkit';

import {getSelectedFolderItems} from './folders.js';
import {getSelectedMosaic} from './mosaics.js';
import {getSelectedSeries} from './series.js';
import {TILE_MODE, UI_MODES} from '@explorer/constants';

const getTileMode = state => state.tiles.mode;
const selectUIMode = state => state.ui.mode;

// ToDo: expand to selected folder item
export const isAnalytic = createSelector(
  [getTileMode, getSelectedMosaic, getSelectedFolderItems, getSelectedSeries],
  (tileMode, selectedMosaic, selectedFolderItems, selectedSeries) => {
    if (tileMode === TILE_MODE.FOLDERS && selectedFolderItems.length > 0) {
      const itemTypes = Array.from(
        new Set(selectedFolderItems.map(item => item.properties.item_type))
      );
      return (
        itemTypes.length === 1 &&
        selectedFolderItems.every(item => item.properties.supports.indexes)
      );
    } else if (
      tileMode === TILE_MODE.BASEMAPS &&
      (selectedMosaic || selectedSeries)
    ) {
      return (
        selectedMosaic?.supports.indexes || selectedSeries?.supports.indexes
      );
    }

    return false;
  }
);

export const canEnhance = createSelector(
  [getTileMode, getSelectedMosaic, getSelectedFolderItems, selectUIMode],
  (tileMode, selectedMosaic, selectedFolderItems, uiMode) => {
    if (tileMode === TILE_MODE.RESULTS || uiMode === UI_MODES.COMPARE) {
      return false;
    }

    if (tileMode === TILE_MODE.FOLDERS && selectedFolderItems.length > 0) {
      const itemTypes = Array.from(
        new Set(selectedFolderItems.map(item => item.properties.item_type))
      );

      return (
        itemTypes.length === 1 &&
        selectedFolderItems.every(item => item.properties.supports.numpy)
      );
    } else if (tileMode === TILE_MODE.BASEMAPS && selectedMosaic) {
      return selectedMosaic.supports.numpy;
    }

    return false;
  }
);

export const canProcess = createSelector(
  [getTileMode, isAnalytic],
  (tileMode, isAnalytic) => {
    if (tileMode === TILE_MODE.RESULTS) {
      return false;
    } else if (tileMode === TILE_MODE.FOLDERS) {
      return isAnalytic;
    }

    return true;
  }
);
